import React, { useState } from "react";
import { Divider, Typography, useMediaQuery } from "@mui/material";

import ExpandInfo from "./ExpandInfo";

const Pas4 = () => {
  const isLaptop = useMediaQuery("(max-width: 1400px)");
  const isMobile = useMediaQuery("(max-width: 1024px)");
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? "20px" : "140px",
          marginRight: isMobile ? -20 : "140px",
          marginTop: isMobile ? -60 : "50px",
        }}
      >
        {!isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: isLaptop ? "79rem" : "67rem",
              width: "4px",
              backgroundColor: "#29348f",
            }}
          />
        ) : (
          ""
        )}
        <div style={{ marginLeft: isMobile ? 10 : 34 }}>
          {isMobile ? (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div
                variant="contained"
                style={{
                  backgroundColor: "black",
                  textTransform: "none",
                  borderRadius: "20px 0px 0px 20px",
                  height: 40,
                  width: 70,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  DEER
                </Typography>
              </div>
              <div
                variant="contained"
                style={{
                  backgroundColor: "#29348f",

                  textTransform: "none",
                  height: 40,
                  width: 80,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  Client
                </Typography>
              </div>
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <div
                variant="contained"
                style={{
                  backgroundColor: "#29348f",
                  textTransform: "none",
                  height: 40,
                  width: 70,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  Client
                </Typography>
              </div>
              <div
                variant="contained"
                style={{
                  backgroundColor: "black",
                  borderRadius: "0px 20px 20px 0px",
                  textTransform: "none",
                  height: 40,
                  width: 80,
                  paddingLeft: 14,
                  paddingTop: 8,
                }}
              >
                <Typography variant="body1" color="white">
                  DEER
                </Typography>
              </div>
            </div>
          )}

          <Typography variant="h6" sx={{ mt: 5 }}>
            Depunerea cererii/notificării pentru încheierea contractului de
            racordare în una dintre următoarele variante de execuție a
            lucrărilor
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            &bull;Cu operatorul de distribuție:
          </Typography>

          <Typography variant="body2" sx={{ mt: 0, ml: 6 }}>
            &bull; Licitație publică
          </Typography>
          <Typography variant="body2" sx={{ mt: 0, ml: 6 }}>
            &bull; Încredințare directă
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            &bull;Direct cu un proiectant/constructor atestat
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Pe perioada de valabilitate a avizului tehnic de racordare
          </Typography>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Întocmire contract de racordare
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            În funcție de varianta aleasă de client
          </Typography>

          <Typography variant="h6" sx={{ mt: 2, color: "#29348f" }}>
            Cât durează?
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            3 zile lucrătoare de la depunerea cererii de racordare/notificării
            și a documentației complete
          </Typography>
          <Typography variant="h6" sx={{ mt: 5 }}>
            Cereri de încheiere a contractelor de racordare
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Contract de execuție încheiat de către Solicitant direct cu un
            executant atestat ANRE
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Notificare-utilizator-incheiere-contract-cu-tert-Ordin-181.doc"
              style={{ color: "#0D6D92" }}
            >
              Notificare
            </a>
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu licitație
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Cerere-incheiere-contract-de-racordare.doc"
              style={{ color: "#0D6D92" }}
            >
              Cerere de încheiere contract de racordare
            </a>
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu atribuire
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Cerere-incheiere-contract-de-racordare-Ordin-18-1.doc"
              style={{ color: "#0D6D92" }}
            >
              Cerere de încheiere contract de racordare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Conventie-de-atribuire-DEER-14.doc"
              style={{ color: "#0D6D92" }}
            >
              Convenție de Atribuire DEER
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Conventie-de-atribuire-Sucursala-17.doc"
              style={{ color: "#0D6D92" }}
            >
              Convenție de Atribuire Sucursală
            </a>
          </Typography>

          <Typography variant="h6" sx={{ mt: 5 }}>
            Toate tipurile de solicitari, cu exceptia celor de la pct. 1
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Contract de execuție încheiat de către Solicitant direct cu un
            executant atestat ANRE
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a href="./Notificare.doc" style={{ color: "#0D6D92" }}>
              Notificare
            </a>
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Contract de executie incheiat prin intermediul operatorului de
            distributie
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu licitație
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Cerere-incheiere-contract-de-racordare.doc"
              style={{ color: "#0D6D92" }}
            >
              Cerere de încheiere contract de racordare
            </a>
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            Cu atribuire
          </Typography>

          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Cerere-incheiere-contract-de-racordare-1.doc"
              style={{ color: "#0D6D92" }}
            >
              Cerere de încheiere contract de racordare
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Conventie-de-atribuire-DEER.doc"
              style={{ color: "#0D6D92" }}
            >
              Convenție de Atribuire DEER
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Conventie-de-atribuire-Sucursala.doc"
              style={{ color: "#0D6D92" }}
            >
              Convenție de Atribuire Sucursală
            </a>
          </Typography>
          {/* <Typography variant="h6" sx={{ mt: 4 }}>
            Formulare racordare la rețea
          </Typography>

          <Typography variant="body2" sx={{ mt: 2, color: "#0D6D92" }}>
            Prosumatori
          </Typography>

          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./5.-Cerere-de-racordare-prosumator-–-prin-programe-de-finantare-Anexa-4.docx"
              style={{ color: "#0D6D92" }}
            >
              Cerere de racordare prosumator – prin programe de finantare.
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./5.-Loc-consum-si_sau-producere-existent-prevazut_cu_instalatii_de_producere_Anexa-nr-5.docx"
              style={{ color: "#0D6D92" }}
            >
              Notificare prosumatori si proiecte demonstrative – Pi mai mica sau
              egală cu 10,8 kW, conexiune diferita de trifazic (Anexa 5)
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./CERERE-PROSUMATOR-mai-mare-400-kW-5.doc"
              style={{ color: "#0D6D92" }}
            >
              Persoane fizice si juridice care au puterea instalata pe producere
              &gt; 400kW
            </a>
          </Typography>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Cererea de racordare este necesar să fie însoțită de urmatoarele
            documente
          </Typography>
          <Typography variant="body2" sx={{ mt: 2 }}>
            <a
              href="./Declaratie-autenticitate-date.doc"
              style={{ color: "#0D6D92" }}
            >
              Declaratie autenticitate date –
            </a>
            Obligatoriu pentru toate tipurile de cereri
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./12-Model-de-imputernicire.pdf"
              style={{ color: "#0D6D92" }}
            >
              Model imputernicire –
            </a>{" "}
            În cazul în care cererea se depune prin împuternicit
          </Typography>
          <Typography variant="body2" sx={{ mt: 0 }}>
            <a
              href="./Nota-informare-clienti-DEER-final.doc"
              style={{ color: "#0D6D92" }}
            >
              Nota de informare generală privind prelucrarea datelor cu caracter
              personal –
            </a>{" "}
            În cazul persoanelor fizice
          </Typography> */}
        </div>
        {isMobile ? (
          <Divider
            orientation="vertical"
            sx={{
              height: "90rem",
              width: "4px",
              backgroundColor: "#29348f",
              ml: 2,
            }}
          />
        ) : (
          ""
        )}
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          marginLeft: isMobile ? -30 : "140px",
          marginTop: "50px",
          marginRight: isMobile ? 0 : "140px",
          marginBottom: "60px",
        }}
      >
        <Divider
          orientation="vertical"
          sx={{ height: "4rem", width: "4px", backgroundColor: "#29348f" }}
        />
        <ExpandInfo />
      </div>
    </div>
  );
};
export default Pas4;
